export const DIFFERENTIATOR_TYPES = {
  PROS_SWT: 'PROS_SWT',
  PROS_MOVE: 'PROS_MOVE',
  CUST_SWT: 'CUST_SWT',
  CUST_MOVE: 'CUST_MOVE',
  CUST_PRCH: 'CUST_PRCH',
};

export const I_WANT_TO = {
  CONNECT_HOME_I_MOVE_TO: {
    value: 'iwt1',
    label: "Connect a home I'm moving into",
  },
  RENEW_CHANGE_MY_PLAN: {
    value: 'iwt2',
    label: 'Renew/change my plan',
  },
  ADD_ANOTHER_FUEL: {
    value: 'iwt3',
    label: 'Add another fuel to my account',
  },
  ADD_ANOTHER_PROPERTY: {
    value: 'iwt4',
    label: 'Add another property to my account',
  },
};
